import React, { useState } from "react";
import logo from "../../assets/trybz-logo.svg";
import bg from "../../assets/bg.svg";
import { Formik } from "formik";
import parsePhoneNumber from "libphonenumber-js";

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import PrimaryButton from "../../utils/buttons/PrimaryButton";
import dayjs from "dayjs";
import execWebRequest from "../../utils/helpers/execWebRequest";
import MobileGatewayService from "../../services/mobile_auth.service";
import { history } from "../..";
import { getUserData, useUserStore } from "../../store/user.store";

const monthsOptions = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  " July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export default function CustomerProfileSetup() {
  const userData = getUserData();
  const store = useUserStore.getState();
  const [phoneNumber, setphoneNumber] = useState(userData?.phoneNumber);
  const [phoneErrors, setphoneErrors] = useState("");

  function submitProfileDataHandler(payload) {
    return execWebRequest({
      execute: () =>
        MobileGatewayService.completeUserProfile({
          phoneNumber: phoneNumber,
          firstName: payload.firstName,
          lastName: payload.lastName,
          gender: payload.gender,
          birthDate: payload.dob,
          idNumber: payload.niNumber,
        }),
      onSuccess: async () => {
        // Check if resident or member to accept respective invites. Endpoints to Accept invites are onlyavailable for resident and tribe hence everyother role redirect to success page
        if (store.inviteId) {
          store.type === "resident_invite"
            ? await MobileGatewayService.residentAcceptInvite(
                store.inviteId
              ).then(() => history.push("/customers/complete-profile/success"))
            : store.type === "tribe_member_invite"
            ? await MobileGatewayService.tribeMemberAcceptInvite(
                store.inviteId
              ).then(() => history.push("/customers/complete-profile/success"))
            : history.push("/customers/complete-profile/success");
        } else {
          history.push("/customers/complete-profile/success");
        }
      },
    });
  }

  return (
    <main
      style={{
        backgroundImage: `url(${bg})`,
      }}
      className="custom-change-pass-container"
    >
      <div
        style={{ background: "rgba(255, 255, 255, 0.6)" }}
        className="custom-change-pass-outer"
      >
        <div className="text-center tw-space-y-4">
          <img
            className="custom-change-pass-image"
            src={logo}
            alt={"trybz-logo"}
            width={100}
            height={100}
          />

          <h1 className="custom-change-pass-title !tw-text-3xl">
            Complete Profile
          </h1>

          <h4 className="custom-change-pass-subtitle !tw-text-base">
            Kindly complete the form below to finish your profile details.{" "}
          </h4>
        </div>

        <Formik
          initialValues={{
            email: userData.email,
            firstName: userData.firstName,
            lastName: userData.lastName,
            gender: userData.gender ?? "",
            phoneNumber: "",
            niNumber: "",
            dob: "",
            month: "",
            day: "",
            year: "",
          }}
          onSubmit={(values, actions) => {
            console.log(values);

            // validate phoneNumber
            const phoneParseResult = parsePhoneNumber(phoneNumber);
            const phoneIsValid = phoneParseResult.isValid();
            if (!phoneIsValid)
              return setphoneErrors(
                "Phone number must be a valid phone number."
              );
            // validate date
            if (values.day === "")
              return actions.setFieldError(
                "dob",
                "Birth date and month is required."
              );

            // merge day, year, month feild values into dob property
            const dobDateObj = new Date();
            dobDateObj.setMonth(Number(values.month));
            dobDateObj.setDate(Number(values.day));

            if (values.year !== "") {
              dobDateObj.setFullYear(Number(values.year));
            } else {
              dobDateObj.setFullYear(1000);
            }
            values.dob = dobDateObj.toISOString();

            // validate gender feild
            if (values.gender === "N/A" || values.gender === "") {
              return actions.setFieldError(
                "gender",
                "Gender is a required field."
              );
            }

            submitProfileDataHandler(values);
          }}
        >
          {(formikProps) => (
            <form
              onSubmit={formikProps.handleSubmit}
              className="custom-change-pass-form"
            >
              <div className="custom-change-pass-form-inner">
                <label
                  htmlFor="email"
                  className="custom-change-pass-form-label"
                >
                  Email
                </label>
                <input
                  onChange={formikProps.handleChange}
                  value={formikProps.values.email}
                  type="email"
                  name="email"
                  readOnly
                  className={` custom-change-pass-form-input !tw-w-full !tw-text-sm `}
                />
                {formikProps.errors.email ? (
                  <div className="custom-change-pass-form-error !tw-text-xs">
                    {formikProps.errors.email}
                  </div>
                ) : null}
              </div>
              <div className="tw-flex tw-justify-between">
                <div className="custom-change-pass-form-inner !tw-w-[180px] ">
                  <label
                    htmlFor="firstName"
                    className="custom-change-pass-form-label"
                  >
                    First name
                  </label>
                  <input
                    value={formikProps.values.firstName}
                    onChange={formikProps.handleChange}
                    name="firstName"
                    type="text"
                    className=" custom-change-pass-form-input !tw-w-full !tw-text-sm  "
                  />{" "}
                  {formikProps.errors.firstName ? (
                    <div className="custom-change-pass-form-error !tw-text-xs">
                      {formikProps.errors.firstName}
                    </div>
                  ) : null}
                </div>
                <div className="custom-change-pass-form-inner !tw-w-[180px] ">
                  <label
                    htmlFor="lastName"
                    className="custom-change-pass-form-label"
                  >
                    Last name
                  </label>
                  <input
                    value={formikProps.values.lastName}
                    onChange={formikProps.handleChange}
                    name="lastName"
                    type="text"
                    className=" custom-change-pass-form-input !tw-w-full !tw-text-sm "
                  />{" "}
                  {formikProps.errors.lastName ? (
                    <div className="custom-change-pass-form-error !tw-text-xs">
                      {formikProps.errors.lastName}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="">
                <label
                  htmlFor="month"
                  className="custom-change-pass-form-label"
                >
                  Date of birth
                </label>
                <div className="tw-grid tw-w-full tw-grid-cols-3 tw-place-content-center tw-gap-x-2  ">
                  <input
                    value={formikProps.values.day}
                    onChange={(event) => {
                      if (event.target.value > 31 || event.target.value < 1) {
                        return formikProps.setFieldValue("day", "");
                      } else {
                        formikProps.setFieldValue("day", event.target.value);
                      }
                    }}
                    name="day"
                    type="text"
                    placeholder="DD"
                    className=" custom-change-pass-form-input !tw-w-[120px] !tw-text-sm  "
                  />
                  <select
                    onChange={formikProps.handleChange}
                    name="month"
                    value={formikProps.values.month}
                    className="custom-change-pass-form-input !tw-w-[120px] !tw-text-sm "
                  >
                    {monthsOptions.map((month, index) => (
                      <option value={index}>{month}</option>
                    ))}
                  </select>
                  <input
                    name="year"
                    value={formikProps.values.year}
                    type="number"
                    onChange={(event) => {
                      let value = event.target.value;
                      if (value.length > 4) {
                        return formikProps.setFieldValue("year", "");
                      } else {
                        if (value.length === 4) {
                          let dayjsConverted = dayjs().year(value);
                          if (dayjsConverted.isAfter(dayjs(), "year")) {
                            return formikProps.setFieldValue("year", "");
                          } else {
                            return formikProps.setFieldValue("year", value);
                          }
                        }
                      }
                      formikProps.setFieldValue("year", value);
                    }}
                    placeholder="YYYY"
                    className=" custom-change-pass-form-input   !tw-w-[120px] !tw-text-sm  "
                  />
                </div>
                {formikProps.errors.dob ? (
                  <div className="custom-change-pass-form-error !tw-text-xs">
                    {formikProps.errors.dob}
                  </div>
                ) : null}
              </div>
              <div className="custom-change-pass-form-inner">
                <label
                  htmlFor="gender"
                  className="custom-change-pass-form-label"
                >
                  Gender
                </label>
                <select
                  onChange={formikProps.handleChange}
                  name="gender"
                  value={formikProps.values.gender}
                  className={` custom-change-pass-form-input !tw-w-full !tw-text-sm   `}
                >
                  <option value="N/A">Select a gender</option>
                  <option value={"male"}>Male</option>
                  <option value={"female"}>Female</option>{" "}
                  <option value={"non-binary"}>Non-binary</option>{" "}
                  <option value={"other"}>Other</option>
                </select>
                {formikProps.errors.gender ? (
                  <div className="custom-change-pass-form-error !tw-text-xs">
                    {formikProps.errors.gender}
                  </div>
                ) : null}
              </div>

              <div className="custom-change-pass-form-inner">
                <label
                  htmlFor="email"
                  className="custom-change-pass-form-label"
                >
                  Phone
                </label>
                <PhoneInput
                  className="custom-change-pass-form-input !tw-w-full  !tw-text-sm"
                  international
                  value={phoneNumber}
                  onChange={(value) => setphoneNumber(value)}
                />
                {phoneErrors ? (
                  <div className="custom-change-pass-form-error !tw-text-xs">
                    {phoneErrors}
                  </div>
                ) : null}
              </div>

              <div className="custom-change-pass-form-inner">
                <label
                  htmlFor="email"
                  className="custom-change-pass-form-label"
                >
                  NI number (optional)
                </label>
                <input
                  onChange={formikProps.handleChange}
                  value={formikProps.values.niNumber}
                  type="text"
                  name="niNumber"
                  className={` custom-change-pass-form-input !tw-w-full !tw-text-sm  `}
                />
                {formikProps.errors.niNumber ? (
                  <div className="custom-change-pass-form-error !tw-text-xs">
                    {formikProps.errors.niNumber}
                  </div>
                ) : null}
              </div>
              <div className="my-3">
                <PrimaryButton text="Complete Profile" />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </main>
  );
}
